import { setIsLoading, setSuccess, setError } from './header-config-slice';
import { getHeaderConfig } from 'api/header-config';
import { getErrors } from 'api/client';

import type { TError } from 'api/client';
import type { Dispatch } from '@reduxjs/toolkit';

import type { AxiosRequestConfig } from 'axios';

export const getHeaderConfigThunk = ({
  requestConfig
}: {
  requestConfig?: AxiosRequestConfig;
}) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading());
    const response = await getHeaderConfig({ requestConfig });
    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e as TError);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
